import React from "react";
import { connect } from "react-redux";
import { SimManager } from "@learningblocks/simulation-engine";
import { ProtocolEquipmentModal } from "@learningblocks/simulations/shared-components";
import type {
  TableConfig,
  CurrentWarning,
  TooltipProps as TooltipState,
} from "@learningblocks/simulations/shared-components/lib/ProtocolModals/ProtocolEquipmentModal";

import {
  setCurrentWeight,
  setTubeMappingtoBeaker,
  setTubesOnScale,
  setWeightsPostDialysis,
  setWeightsPreDialysis,
  showTooltip,
  hideTooltip,
  setTubeBeakerNumber,
  setMassRecorded,
} from "./Store/actions";

import ElectronicScale_Empty from "./images/ElectronicScale_Empty.svg";

import ElectronicScale_1Tube_1 from "./images/Scale_1Tube_1.svg";
import ElectronicScale_1Tube_1_Wet from "./images/Scale_1Tube_1_Wet.svg";
import ElectronicScale_1Tube_2 from "./images/Scale_1Tube_2.svg";
import ElectronicScale_1Tube_2_Wet from "./images/Scale_1Tube_2_Wet.svg";
import ElectronicScale_1Tube_3 from "./images/Scale_1Tube_3.svg";
import ElectronicScale_1Tube_3_Wet from "./images/Scale_1Tube_3_Wet.svg";
import ElectronicScale_1Tube_4 from "./images/Scale_1Tube_4.svg";
import ElectronicScale_1Tube_4_Wet from "./images/Scale_1Tube_4_Wet.svg";
import ElectronicScale_1Tube_5 from "./images/Scale_1Tube_5.svg";
import ElectronicScale_1Tube_5_Wet from "./images/Scale_1Tube_5_Wet.svg";
import ElectronicScale_1Tube_6 from "./images/Scale_1Tube_6.svg";
import ElectronicScale_1Tube_6_Wet from "./images/Scale_1Tube_6_Wet.svg";

import ElectronicScale_2Tubes_1 from "./images/Scale_2Tubes_1.svg";
import ElectronicScale_2Tubes_1_Wet from "./images/Scale_2Tubes_1_Wet.svg";
import ElectronicScale_2Tubes_2 from "./images/Scale_2Tubes_2.svg";
import ElectronicScale_2Tubes_2_Wet from "./images/Scale_2Tubes_2_Wet.svg";
import ElectronicScale_2Tubes_3 from "./images/Scale_2Tubes_3.svg";
import ElectronicScale_2Tubes_3_Wet from "./images/Scale_2Tubes_3_Wet.svg";
import ElectronicScale_2Tubes_4 from "./images/Scale_2Tubes_4.svg";
import ElectronicScale_2Tubes_4_Wet from "./images/Scale_2Tubes_4_Wet.svg";
import ElectronicScale_2Tubes_5 from "./images/Scale_2Tubes_5.svg";
import ElectronicScale_2Tubes_5_Wet from "./images/Scale_2Tubes_5_Wet.svg";
import ElectronicScale_2Tubes_6 from "./images/Scale_2Tubes_6.svg";
import ElectronicScale_2Tubes_6_Wet from "./images/Scale_2Tubes_6_Wet.svg";

import ElectronicScale_3Tubes_1 from "./images/Scale_3Tubes_1.svg";
import ElectronicScale_3Tubes_1_Wet from "./images/Scale_3Tubes_1_Wet.svg";
import ElectronicScale_3Tubes_2 from "./images/Scale_3Tubes_2.svg";
import ElectronicScale_3Tubes_2_Wet from "./images/Scale_3Tubes_2_Wet.svg";
import ElectronicScale_3Tubes_3 from "./images/Scale_3Tubes_3.svg";
import ElectronicScale_3Tubes_3_Wet from "./images/Scale_3Tubes_3_Wet.svg";
import ElectronicScale_3Tubes_4 from "./images/Scale_3Tubes_4.svg";
import ElectronicScale_3Tubes_4_Wet from "./images/Scale_3Tubes_4_Wet.svg";
import ElectronicScale_3Tubes_5 from "./images/Scale_3Tubes_5.svg";
import ElectronicScale_3Tubes_5_Wet from "./images/Scale_3Tubes_5_Wet.svg";
import ElectronicScale_3Tubes_6 from "./images/Scale_3Tubes_6.svg";
import ElectronicScale_3Tubes_6_Wet from "./images/Scale_3Tubes_6_Wet.svg";

type beakerLetter = [string, string, string, string, string, string];

interface OsmosisElectronicScaleProps {
  show: boolean;
  close: () => void;
  currentWeight: number;
  tubesOnScale: [boolean, boolean, boolean, boolean, boolean, boolean];
  tubeMappingtoBeaker: any[];
  tubeBeakerNumber: beakerLetter;
  tubeWeightsPreDialysis: any[];
  tubeWeightsPostDialysis: any[];
  tooltip: TooltipState;
  concentration: any;
  tubeMassRecorded: any[];
  setCurrentWeight: (data: number) => void;
  setTubesOnScale: (
    data: [boolean, boolean, boolean, boolean, boolean, boolean]
  ) => void;
  setTubeMappingtoBeaker: (data: any[]) => void;
  setTubeBeakerNumber: (data: beakerLetter) => void;
  setWeightsPreDialysis: (data: any[]) => void;
  setWeightsPostDialysis: (data: any[]) => void;
  setMassRecorded: (data: Record<number, boolean[]>) => void;
  showTooltip: (data: TooltipState) => void;
  hideTooltip: () => void;
}

class OsmosisElectronicScale extends React.Component<
  OsmosisElectronicScaleProps,
  { recorded: Record<number, boolean[]> }
> {
  private electronicScaleImage: any;
  private tubeWeights_0: number[];
  private beakerImpact_0: number[];
  private tubeWeights_1: number[];
  private beakerImpact_1: number[];
  private tubeWeights: number[];
  private beakerImpact: number[];
  private errorOffSet: number;
  private weightOffSet: number;
  private beakers: beakerLetter;
  state: { recorded: Record<number, boolean[]> } = { recorded: {} };

  constructor(props: OsmosisElectronicScaleProps) {
    super(props);

    this.electronicScaleImage = ElectronicScale_Empty;

    this.errorOffSet = Math.random() * (0.2 - 0.02) + 0.02;
    this.weightOffSet = Math.random() * (0.38 - 0.12) + 0.12;
    this.beakers = ["_", "_", "_", "_", "_", "_"];

    this.tubeWeights_0 = [10.71, 10.72, 10.61, 10.66, 10.51, 10.61];
    this.beakerImpact_0 = [-7.19, 0.09, -18.57, -12.57, -24.45, -25.64];

    this.tubeWeights_1 = [12.09, 11.98, 12.04, 12.31, 12.24, 12.15];
    this.beakerImpact_1 = [13.15, 23.87, 4.82, 4.82, 0.65, 0.08];

    this.tubeWeights = [10.71, 10.72, 10.61, 10.66, 10.51, 10.61];
    this.beakerImpact = [-7.19, 0.09, -18.57, -12.57, -24.45, -25.64];
  }

  UpdateOffsets = () => {
    this.errorOffSet = Math.random() * (0.2 - 0.02) + 0.02;
    this.weightOffSet = Math.random() * (0.38 - 0.12) + 0.12;
  };

  UpdateRecordedWarning = () => {
    let onScale = -1;
    for (let i = 1; i < 7; i++) {
      if (
        SimManager.getInstance()
          .getState("tube_" + i)
          ?.includes("onScale")
      )
        onScale = i;
    }
    const timer = SimManager.getInstance().getState("timer");

    if (onScale == -1) return;

    const tubeWeight = SimManager.getInstance().getInputValue(
      "tube_" + onScale
    );
    const records = this.props.tubeMassRecorded;

    if (timer !== "set") {
      if (
        tubeWeight &&
        Object.prototype.hasOwnProperty.call(tubeWeight, "initialWeight") &&
        tubeWeight.initialWeight === true &&
        records[onScale - 1][0] != true
      ) {
        const updatedRecords = records.map((record, index) =>
          index === onScale - 1 ? [true, record[1]] : record
        );
        this.props.setMassRecorded(updatedRecords);
      }
    } else {
      if (
        tubeWeight &&
        Object.prototype.hasOwnProperty.call(tubeWeight, "postWeight") &&
        tubeWeight.postWeight === true &&
        records[onScale - 1][1] != true
      ) {
        const updatedRecords = records.map((record, index) =>
          index === onScale - 1 ? [record[0], true] : record
        );
        this.props.setMassRecorded(updatedRecords);
      }
    }
  };

  UpdateWeight() {
    if (this.props.concentration == 0) {
      this.tubeWeights = this.tubeWeights_0;
      this.beakerImpact = this.beakerImpact_0;
    } else {
      this.tubeWeights = this.tubeWeights_1;
      this.beakerImpact = this.beakerImpact_1;
    }
    let weight = 0;

    for (let i = 1; i <= 6; i++) {
      if (
        SimManager.getInstance()
          .getState("tube_" + i)
          ?.includes("onScale")
      ) {
        if (
          SimManager.getInstance()
            .getState("tube_" + i)
            ?.includes("Solution")
        ) {
          const beakerNumber = this.mapLettertoNumber(this.beakers[i - 1]);
          weight +=
            this.tubeWeights[i - 1] *
            (1 + this.beakerImpact[beakerNumber - 1] / 100);
        } else {
          weight += this.tubeWeights[i - 1];
        }

        if (
          SimManager.getInstance()
            .getState("tube_" + i)
            ?.includes("wet")
        ) {
          weight += weight * this.weightOffSet;
        }
      }
    }

    const balanceScale =
      SimManager.getInstance().getInputValue("balance_scale");

    if (
      balanceScale &&
      Object.prototype.hasOwnProperty.call(balanceScale, "errorFixed")
    ) {
      if (!SimManager.getInstance().getInputValue("balance_scale").errorFixed)
        weight += this.errorOffSet;
    }

    if (
      balanceScale &&
      Object.prototype.hasOwnProperty.call(balanceScale, "currentWeight")
    ) {
      SimManager.getInstance().setText(
        "Scale",
        this.props.currentWeight.toFixed(2) + "g"
      );
      SimManager.getInstance().setInputValue("Scale", {
        currentWeight: this.props.currentWeight.toFixed(2),
        preWeights: [...this.props.tubeWeightsPreDialysis],
        postWeights: [...this.props.tubeWeightsPostDialysis],
      });
    }

    this.props.setCurrentWeight(parseFloat(weight.toFixed(2)));
  }

  handleRecordButtonClick = (
    rowId: string,
    cellId: string,
    target: HTMLElement
  ) => {
    const beakerNumber = parseInt(rowId.replace("beaker-", ""));
    const buttonNumber = cellId.includes("initial") ? 1 : 2;

    this.props.setTubeBeakerNumber(this.beakers);

    const onScale = [];
    for (let i = 1; i < 7; i++) {
      if (
        SimManager.getInstance()
          .getState("tube_" + i)
          ?.includes("onScale")
      )
        onScale.push(i);
    }
    const timer = SimManager.getInstance().getState("timer");

    if (onScale.length > 1) {
      if ((target as any).getBoundingClientRect) {
        this.props.showTooltip({
          visible: true,
          pos: (target as any).getBoundingClientRect(),
          title: "Hint",
          message: "Two tubes are on the scale, please remove 1",
        });
      }
      return;
    }

    if (onScale.length === 0) {
      if ((target as any).getBoundingClientRect) {
        this.props.showTooltip({
          visible: true,
          pos: (target as any).getBoundingClientRect(),
          title: "Hint",
          message: "There are no tubes on scale",
        });
      }
      return;
    }

    if (beakerNumber !== onScale[0]) {
      if ((target as any).getBoundingClientRect) {
        this.props.showTooltip({
          visible: true,
          pos: (target as any).getBoundingClientRect(),
          title: "Hint",
          message: `This isn't tube ${onScale[0]}`,
        });
      }
      return;
    }

    if (buttonNumber === 1 && timer === "set") {
      if ((target as any).getBoundingClientRect) {
        this.props.showTooltip({
          visible: true,
          pos: (target as any).getBoundingClientRect(),
          title: "Hint",
          message: `Dialysis has already occurred. Please record the Post-Osmosis Mass instead.`,
        });
      }
      return;
    }

    if (buttonNumber === 2 && timer !== "set") {
      if ((target as any).getBoundingClientRect) {
        this.props.showTooltip({
          visible: true,
          pos: (target as any).getBoundingClientRect(),
          title: "Hint",
          message: `Are you sure Osmosis has taken place yet?`,
        });
      }
      return;
    }

    const tubeMapping: any[] = [...this.props.tubeMappingtoBeaker];

    if (tubeMapping[beakerNumber - 1] == -1) {
      tubeMapping[beakerNumber - 1] = onScale[0];
      this.props.setTubeMappingtoBeaker(tubeMapping);
    } else {
      if (beakerNumber != onScale[0]) {
        if ((target as any).getBoundingClientRect) {
          this.props.showTooltip({
            visible: true,
            pos: (target as any).getBoundingClientRect(),
            title: "Hint",
            message:
              "The wrong button is pressed. Press correct button with correct tube",
          });
        }
        return;
      }
    }

    if (buttonNumber == 1) {
      const preDialysisWeights: any[] = [...this.props.tubeWeightsPreDialysis];
      preDialysisWeights[beakerNumber - 1] = this.props.currentWeight;
      this.props.setWeightsPreDialysis(preDialysisWeights);
      SimManager.getInstance().setInputValue("tube_" + onScale[0], {
        initialWeight: true,
      });
      const records = { ...this.state.recorded };
      records[onScale[0]] = timer === "set" ? [true, true] : [true, false];
      this.setState({ recorded: records });
      this.props.hideTooltip();
    } else {
      const postDialysisWeights: any[] = [
        ...this.props.tubeWeightsPostDialysis,
      ];
      postDialysisWeights[beakerNumber - 1] = this.props.currentWeight;
      this.props.setWeightsPostDialysis(postDialysisWeights);
      SimManager.getInstance().setInputValue("tube_" + onScale[0], {
        postWeight: true,
      });
      const records = { ...this.state.recorded };
      records[onScale[0]] = timer === "set" ? [true, true] : [true, false];
      this.setState({ recorded: records });
      this.props.hideTooltip();
    }

    SimManager.getInstance().handleUpdateItems();
  };

  handleZeroButtonClick = () => {
    if (SimManager.getInstance().getState("Scale") == "error") {
      this.props.setCurrentWeight(0);
      SimManager.getInstance().setInputValue("balance_scale", {
        errorFixed: true,
      });
      this.UpdateOffsets();
      SimManager.getInstance().updateState("Scale", "zero");
      setTimeout(() => {
        SimManager.getInstance().handleUpdateItems();
      }, 100);
    }
  };

  computeScaleImage = (): string => {
    const onScale = [];
    for (let i = 1; i < 7; i++) {
      if (
        SimManager.getInstance()
          .getState("tube_" + i)
          ?.includes("onScale")
      )
        onScale.push(i);
    }

    if (onScale.length == 0) return ElectronicScale_Empty;

    if (onScale.length == 1) {
      const isWet = SimManager.getInstance()
        .getState("tube_" + onScale[0])
        ?.includes("wet");

      if (!isWet) {
        switch (onScale[0]) {
          case 1:
            return ElectronicScale_1Tube_1;
          case 2:
            return ElectronicScale_1Tube_2;
          case 3:
            return ElectronicScale_1Tube_3;
          case 4:
            return ElectronicScale_1Tube_4;
          case 5:
            return ElectronicScale_1Tube_5;
          case 6:
            return ElectronicScale_1Tube_6;
        }
      } else {
        switch (onScale[0]) {
          case 1:
            return ElectronicScale_1Tube_1_Wet;
          case 2:
            return ElectronicScale_1Tube_2_Wet;
          case 3:
            return ElectronicScale_1Tube_3_Wet;
          case 4:
            return ElectronicScale_1Tube_4_Wet;
          case 5:
            return ElectronicScale_1Tube_5_Wet;
          case 6:
            return ElectronicScale_1Tube_6_Wet;
        }
      }
    }

    if (onScale.length == 2) {
      const isWet = SimManager.getInstance()
        .getState("tube_" + onScale[0])
        ?.includes("wet");

      if (!isWet) {
        switch (onScale[0]) {
          case 1:
            return ElectronicScale_2Tubes_1;
          case 2:
            return ElectronicScale_2Tubes_2;
          case 3:
            return ElectronicScale_2Tubes_3;
          case 4:
            return ElectronicScale_2Tubes_4;
          case 5:
            return ElectronicScale_2Tubes_5;
          case 6:
            return ElectronicScale_2Tubes_6;
        }
      } else {
        switch (onScale[0]) {
          case 1:
            return ElectronicScale_2Tubes_1_Wet;
          case 2:
            return ElectronicScale_2Tubes_2_Wet;
          case 3:
            return ElectronicScale_2Tubes_3_Wet;
          case 4:
            return ElectronicScale_2Tubes_4_Wet;
          case 5:
            return ElectronicScale_2Tubes_5_Wet;
          case 6:
            return ElectronicScale_2Tubes_6_Wet;
        }
      }
    }

    if (onScale.length == 3) {
      const isWet = SimManager.getInstance()
        .getState("tube_" + onScale[0])
        ?.includes("wet");

      if (!isWet) {
        switch (onScale[0]) {
          case 1:
            return ElectronicScale_3Tubes_1;
          case 2:
            return ElectronicScale_3Tubes_2;
          case 3:
            return ElectronicScale_3Tubes_3;
          case 4:
            return ElectronicScale_3Tubes_4;
          case 5:
            return ElectronicScale_3Tubes_5;
          case 6:
            return ElectronicScale_3Tubes_6;
        }
      } else {
        switch (onScale[0]) {
          case 1:
            return ElectronicScale_3Tubes_1_Wet;
          case 2:
            return ElectronicScale_3Tubes_2_Wet;
          case 3:
            return ElectronicScale_3Tubes_3_Wet;
          case 4:
            return ElectronicScale_3Tubes_4_Wet;
          case 5:
            return ElectronicScale_3Tubes_5_Wet;
          case 6:
            return ElectronicScale_3Tubes_6_Wet;
        }
      }
    }

    return ElectronicScale_Empty;
  };

  UpdateBeakers = () => {
    for (let i = 1; i < 7; i++) {
      const itemValue = SimManager.getInstance().getInputValue("tube_" + i);
      if (
        itemValue &&
        Object.prototype.hasOwnProperty.call(itemValue, "beaker")
      ) {
        this.beakers[i - 1] = this.mapNumbertoLetter(itemValue.beaker);
      }
    }
  };

  mapNumbertoLetter(number: string): string {
    switch (number) {
      case "1":
        return "A";
      case "2":
        return "B";
      case "3":
        return "C";
      case "4":
        return "D";
      case "5":
        return "E";
      case "6":
        return "F";
    }
    return "_";
  }

  mapLettertoNumber(letter: string): number {
    switch (letter) {
      case "A":
        return 1;
      case "B":
        return 2;
      case "C":
        return 3;
      case "D":
        return 4;
      case "E":
        return 5;
      case "F":
        return 6;
    }
    return 0;
  }

  sanitizeWeights(weights: number[] | string[]) {
    return weights.map((value) => {
      const number = parseFloat(value as string);
      return parseFloat(number.toFixed(2));
    });
  }

  computeTableConfig = (): TableConfig => {
    const preDialysisWeights = this.sanitizeWeights(
      this.props.tubeWeightsPreDialysis
    );
    const postDialysisWeights = this.sanitizeWeights(
      this.props.tubeWeightsPostDialysis
    );

    const timer = SimManager.getInstance().getState("timer");
    const dialysisOccurred = timer === "set";

    return {
      headers: ["Beaker", "#", "Initial Mass", "Post-Osmosis Mass"],
      rows: this.beakers.map((beaker, index) => ({
        id: `beaker-${index + 1}`,
        cells: [
          {
            value: beaker,
            ariaLabel: `Beaker number ${beaker}`,
          },
          {
            value: index + 1,
            ariaLabel: `Tube number ${index + 1}`,
          },
          {
            value:
              preDialysisWeights[index] === -1
                ? "-"
                : preDialysisWeights[index].toFixed(2),
            showRecordButton: true,
            recordButtonDisabled: dialysisOccurred,
            recordButtonId: `beaker-${index + 1}-initial`,
            ariaLabel: `Initial recorded mass ${
              preDialysisWeights[index] === -1
                ? "-"
                : preDialysisWeights[index].toFixed(2)
            }`,
          },
          {
            value:
              postDialysisWeights[index] === -1
                ? "-"
                : postDialysisWeights[index].toFixed(2),
            showRecordButton: true,
            recordButtonDisabled: !dialysisOccurred,
            recordButtonId: `beaker-${index + 1}-post`,
            ariaLabel: `Final recorded mass ${
              postDialysisWeights[index] === -1
                ? "-"
                : postDialysisWeights[index].toFixed(2)
            }`,
          },
        ],
      })),
      ariaLabel:
        "An electronic balance scale with a zero button. There's a widget for recording the initial mass of dialysis tubes.",
    };
  };

  computeCurrentWarning = (): CurrentWarning | undefined => {
    let onScale = -1;
    for (let i = 1; i < 7; i++) {
      if (
        SimManager.getInstance()
          .getState("tube_" + i)
          ?.includes("onScale")
      )
        onScale = i;
    }

    if (onScale === -1) return undefined;

    const postOsmosis =
      SimManager.getInstance().getState("timer") === "set" ? 1 : 0;
    const warning = postOsmosis
      ? this.props.tubeMassRecorded[onScale - 1][1]
      : this.props.tubeMassRecorded[onScale - 1][0];

    return {
      message: `Mass recorded: ${warning ? "Yes" : "No"}`,
      type: warning ? "success" : "error",
    };
  };

  render() {
    this.UpdateWeight();
    this.UpdateBeakers();
    this.UpdateRecordedWarning();

    return (
      <ProtocolEquipmentModal
        show={this.props.show}
        close={this.props.close}
        equipmentImage={this.computeScaleImage()}
        value={this.props.currentWeight}
        tableConfig={this.computeTableConfig()}
        tooltip={this.props.tooltip}
        title="Record the initial mass"
        description="Record the initial mass of each tube by clicking the 'Record' button"
        footerConfig={{
          heading: "Double check",
          content: "Make sure you have recorded the value before exiting.",
        }}
        currentWarning={this.computeCurrentWarning()}
        onRecordButtonClick={this.handleRecordButtonClick}
        onZeroButtonClick={this.handleZeroButtonClick}
      />
    );
  }
}

interface ModalState {
  dialysisConcentration: any;
  electronicScale: ModalState;
  showModal: boolean;
  currentWeight: number;
  tubesOnScale: [boolean, boolean, boolean, boolean, boolean, boolean];
  tubeMappingtoBeaker: any[];
  tubeWeightsPreDialysis: any[];
  tubeWeightsPostDialysis: any[];
  tooltip: TooltipState;
  tubeBeakerNumber: beakerLetter;
  tubeMassRecorded: any[];
}

const mapStateToProps = (state: ModalState) => {
  const electronicScaleModalState: ModalState = state.electronicScale;
  return {
    currentWeight: electronicScaleModalState.currentWeight,
    tubesOnScale: electronicScaleModalState.tubesOnScale,
    tubeMappingtoBeaker: electronicScaleModalState.tubeMappingtoBeaker,
    tubeBeakerNumber: electronicScaleModalState.tubeBeakerNumber,
    tubeWeightsPreDialysis: electronicScaleModalState.tubeWeightsPreDialysis,
    tubeWeightsPostDialysis: electronicScaleModalState.tubeWeightsPostDialysis,
    tooltip: electronicScaleModalState.tooltip,
    concentration: state.dialysisConcentration.concentration,
    tubeMassRecorded: electronicScaleModalState.tubeMassRecorded,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  setCurrentWeight: (data: number) => dispatch(setCurrentWeight(data)),
  setTubesOnScale: (
    data: [boolean, boolean, boolean, boolean, boolean, boolean]
  ) => dispatch(setTubesOnScale(data)),
  setTubeMappingtoBeaker: (data: any[]) =>
    dispatch(setTubeMappingtoBeaker(data)),
  setTubeBeakerNumber: (data: beakerLetter) =>
    dispatch(setTubeBeakerNumber(data)),
  setWeightsPreDialysis: (data: any[]) => dispatch(setWeightsPreDialysis(data)),
  setWeightsPostDialysis: (data: any[]) =>
    dispatch(setWeightsPostDialysis(data)),
  setMassRecorded: (data: Record<number, boolean[]>) =>
    dispatch(setMassRecorded(data)),
  showTooltip: (data: TooltipState) => {
    dispatch(showTooltip(data));
    setTimeout(() => dispatch(hideTooltip()), 3000);
  },
  hideTooltip: () => dispatch(hideTooltip()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OsmosisElectronicScale);
